import { TableSortTypes } from "../enums/ViewListingTypes";

export const getTableSortOrder = (sortBy, sortOrder, columnKey) => {
  if (sortBy !== columnKey) return undefined;

  return sortOrder === TableSortTypes.ASCEND ? "ascend" : "descend";
};
